import { useRef, useState, useEffect } from 'react'
import useAuth from '../hooks/useAuth'
import { useNavigate, useLocation } from 'react-router-dom'
import axios from '../api/axios'
import useInput from '../hooks/useInput'
import useToggle from '../hooks/useToggle'
import background_img from '../assets/sign-in.jpg'
import { Button, IconButton } from "@mui/material"
import RotateRightIcon from '@mui/icons-material/RotateRight';


const LOGIN_URL = '/sign-in';
const grant_type = 'password';

const LogIn = () => {
    useEffect(() => {
        document.title = 'Sign In | Fretless Finance';
    }, []);

    const { setAuth } = useAuth();

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/dashboard"

    const userRef = useRef();
    const errRef = useRef();
    const effectRan = useRef(false);

    const [username, resetUser, userAttribs] = useInput('username', '');
    const [password, setPwd] = useState('');
    const [errMsg, setErrMsg] = useState('');
    const [check, toggleCheck] = useToggle('persist', false);

    var [sectionHeight, setSectionHeight] = useState("425px");
    var [loading, setLoading] = useState(false);

    useEffect(() => {
        userRef.current.focus();
    }, [])

    useEffect(() => {
        setErrMsg('');
        setSectionHeight("410px")
    }, [username, password])

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setSectionHeight(Number(sectionHeight.replace(/px$/, '')) + 25 + "px")

        try {
            var formData = new FormData();
            formData.append("username", username);
            formData.append("password", password);
            const response = await axios({
                method: 'post',
                url: LOGIN_URL,
                data: formData,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            });

            const access_token = response?.data?.access_token;
            setAuth({ username, access_token });
            resetUser();
            setPwd('');
            navigate(from, { replace: true });
        } catch (err) {
            setLoading(false);
            setSectionHeight(Number(sectionHeight.replace(/px$/, '')) - 25 + "px")
            if (!err?.response) {
                setSectionHeight("485px")
                setErrMsg('No Server Response');
            } else if (err.response?.status === 400) {
                setSectionHeight("485px")
                setErrMsg('Missing Username or Password');
            } else if (err.response?.status === 401) {
                setSectionHeight("485px")
                setErrMsg('Unauthorized')
            } else {
                setSectionHeight("485px")
                setErrMsg('Login Failed')
            }
            errRef.current.focus();
        }
    }

    useEffect(() => {
        const listener = event => {
            if (event.keyCode === 13 || event.code === "Enter" || event.code === "NumpadEnter") { // 13 is "enter" key

                // event.preventDefault();
                handleSubmit(event)
            }
        };
        document.addEventListener("keydown", listener);
        return () => {
            document.removeEventListener("keydown", listener);
        };
    }, []);

    // const togglePersist = () => {
    //     setPersist(prev => !persist);
    // }

    //     useEffect(() => {
    //         localStorage.setItem("persist", persist);
    //     }, [persist])

    return (
        <div style={{
            backgroundImage: `url(${background_img})`,
            backgroundRepeat: "no",
            backgroundSize: "cover"
        }}>

            <div style={{ height: "20vh" }}>
            </div>

            <section
                style={{
                    height: sectionHeight,
                    marginRight: "12%",
                    // marginLeft: `min(50px)`
                }}>
                <p ref={errRef} className={errMsg ? "errmsg" :
                    "offscreen"} aria-live="assertive">{errMsg}</p>
                <h1 style={{ fontSize: 36, marginBottom: 0 }}>SIGN IN</h1>

                <form onSubmit={handleSubmit}>
                    <label htmlFor="username" style={{ marginTop: '1rem' }}>Username:</label>
                    <input
                        type="text"
                        id="username"
                        ref={userRef}
                        autoComplete="off"
                        {...userAttribs}
                        required
                    />
                    <label htmlFor="password" style={{ marginTop: '1rem' }}>Password:</label>
                    <input
                        type="password"
                        id="password"
                        onChange={(e) => setPwd(e.target.value)}
                        value={password}
                        required
                    />
                    <br />
                    {(loading) ? <RotateRightIcon
                        className="rotate-icon"
                        style={{ marginLeft: "45%" }} /> : ""}
                    <Button onClick={handleSubmit}
                        variant="contained" style={{ marginTop: 20, marginBottom: 0 }}>
                        Sign In
                    </Button>
                    <br />
                    <div className='persistCheck'>
                        <input
                            type="checkbox"
                            id="persist"
                            onChange={toggleCheck}
                            checked={check}
                        />
                        <label htmlFor='persist' style={{ marginTop: '1rem' }}>Trust This Device?</label>
                    </div>
                </form>
            </section>
            <div style={{ height: "35vh" }}>
            </div>

        </div >

    )
}

export default LogIn